document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.fbt-section').forEach(section => {
    const form = section.querySelector('form');
    const addBtn = section.querySelector('.fbt-add-btn');
    const totalEl = section.querySelector('.bundle-total span');
    const mainVariantId = parseInt(addBtn.dataset.mainVariant, 10);
    const mainButtonText = addBtn.textContent;
    
    // Get the base price of the main product
    const mainPrice = parseInt(form.querySelector('.fbt-item.main-item .price[data-price]').dataset.price, 10) || 0;

    // ------------------
    // Total calculation
    // ------------------
    function updateTotal() {
      // Start with the main price as the base
      let total = mainPrice; 
      
      // Loop through only the ADDITIONAL checked items
      // We skip the main checkbox using :not(.hidden-checkbox)
      form.querySelectorAll('.fbt-checkbox:checked:not(.hidden-checkbox)').forEach(cb => {
        total += parseInt(cb.dataset.price, 10) || 0;
      });

      if (window.Shopify && Shopify.formatMoney) {
        totalEl.textContent = Shopify.formatMoney(total);
      } else {
        // Fallback if Shopify.formatMoney isn't available
        totalEl.textContent = '£' + (total / 100).toFixed(2);
      }
    }

    updateTotal();
    form.addEventListener('change', updateTotal);

    // ------------------
    // Add to cart
    // ------------------
    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      // Start the array with the main product
      const items = [{ id: mainVariantId, quantity: 1 }];
      
      // Push only the OTHER checked products into the array
      form.querySelectorAll('.fbt-checkbox:checked:not(.hidden-checkbox)').forEach(cb => {
        items.push({ id: parseInt(cb.value, 10), quantity: 1 });
      });

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!response.ok) throw new Error('Network response was not ok');

        // Reset button state
        function resetBtn() {
          addBtn.disabled = false;
          addBtn.textContent = mainButtonText;
        }

        // Listen once for the cart drawer refresh event to reset button
        function onDrawerRefresh() {
          resetBtn();
          document.removeEventListener('dispatch:cart-drawer:refresh', onDrawerRefresh);
        }

        document.addEventListener('dispatch:cart-drawer:refresh', onDrawerRefresh);

        // Trigger cart drawer refresh and open
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

        // Quick popup fallback if drawer event doesn't trigger
        if (window.theme && typeof theme.showQuickPopup === 'function') {
          theme.showQuickPopup('Bundle added to cart!', addBtn);
        }

        // Safety timeout to reset button if no drawer event occurs
        setTimeout(resetBtn, 2000);

      } catch (err) {
        console.error('FBT add to cart error:', err);
        addBtn.disabled = false;
        addBtn.textContent = mainButtonText;
      }
    });
  });
});